module.exports = __webpack_public_path__ + "static/media/3DPPA38.224e6730.jpg";